export default class CommentForm {
  constructor() {
    this.selector = 'form#new_comment textarea';
    this.form = 'form#new_comment';
    this.formEntrySelector = 'form#new_comment .comments__entry';
    this.cancelButtonSelector = 'form#new_comment .comments__cancel';
  }

  init() {
    this.element = $(this.selector);
    this.forms = $(this.form);
    this.formEntry = $(this.formEntrySelector);
    this.cancelButton = $(this.cancelButtonSelector);
    this.bindOnFocus();
    this.bindOnSubmit();
    this.bindOnCancel();
  }

  bindOnFocus() {
    this.element.on('focus', this.onFocus.bind(this));
  }

  onFocus() {
    if(window.player) {
      window.player.tech().pause();
    }
    this.formEntry.addClass("active");
  }

  bindOnSubmit(){
    this.forms.on('submit', this.onSubmit);
  }

  onSubmit(){
    if(window.player) {
      window.player.tech().play();
    }
  }

  bindOnCancel() {
    this.cancelButton.on("click", this.onCancel.bind(this));
  }

  onCancel() {
    this.formEntry.removeClass("active");
    this.element.val("");
    this.element.attr("style", "");
  }
}
